import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7f336cd1"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = ["textContent"]
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SvgIcon = _resolveComponent("SvgIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("img", {
      class: "img",
      src: $props.item.BannerURL,
      alt: $props.item.BannerTitle
    }, null, 8, _hoisted_1),
    _createElementVNode("div", {
      class: "title",
      textContent: _toDisplayString($props.item.EventTitle)
    }, null, 8, _hoisted_2),
    _createElementVNode("h5", {
      class: "description",
      textContent: _toDisplayString($props.item.EventTimeDetails)
    }, null, 8, _hoisted_3),
    _createElementVNode("div", {
      class: "details",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.onMoreClicked && $setup.onMoreClicked(...args)))
    }, [
      _createElementVNode("h4", {
        class: "fw6 more-detail",
        textContent: _toDisplayString(_ctx.$t('more-detail'))
      }, null, 8, _hoisted_4),
      _createVNode(_component_SvgIcon, {
        class: "icon-right",
        "icon-name": "arrow-right"
      })
    ])
  ]))
}